import React from "react";
import CountUp from "react-countup";
import { Bath, Package, PlusCircle, TrendingUp } from "lucide-react";

import { PackagesReportController } from "../../../../services/controllers/reports";
import { usePackagesReport } from "../../../../store/reports/usePackagesReport";

import { Summary } from "../../../../components/ui/Summary";

export function PackagesReportSummary() {
  const CPackagesReport = PackagesReportController();

  const summary = usePackagesReport((st) => st.data.summary);
  const filter = usePackagesReport((st) => st.data.filter);
  const loading = usePackagesReport((st) => st.data.isLoading);

  const filtered = filter.status !== "*";

  const clearAll = () => {
    CPackagesReport.setFilter({ status: "*" });
    CPackagesReport.filterPackages();
  };

  return (
    <Summary.Root>
      <Summary.Box active={!filtered} onClick={filtered ? clearAll : undefined}>
        <Summary.Icon icon={Package} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp end={loading ? 0 : summary.packagesSold} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Pacotes vendidos</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box
        active={filter.status === "ABERTO"}
        onClick={() => CPackagesReport.toggleFilter({ status: "ABERTO" })}
      >
        <Summary.Icon icon={Bath} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp end={loading ? 0 : summary.bathOpens} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Banhos em aberto</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box
        active={filter.status === "ABERTO"}
        onClick={() => CPackagesReport.toggleFilter({ status: "ABERTO" })}
      >
        <Summary.Icon icon={PlusCircle} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp end={loading ? 0 : summary.servicesOpens} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Adicionais em aberto</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      {/* KPI de dinheiro nao filtra: nao existe filtro correspondente */}
      <Summary.Box>
        <Summary.Icon icon={TrendingUp} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp
              end={loading ? 0 : summary.revenue}
              prefix="R$ "
              separator="."
              decimal=","
              decimals={2}
              preserveValue
              useEasing
            />
          </Summary.Title>
          <Summary.Text>Receita</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>
    </Summary.Root>
  );
}
